import React from 'react';
import _ from 'lodash';
import Template from './components/Template';
import AwaitingSubmissionBids from './AwaitingSubmissionBids';
import BidOpenReview from './BidOpenReview';
import { NodeEnum } from 'containers/OutBidding/utils';

export const QUARTER_COL_PROPS = {
  itemColProps: { span: 6 },
  itemLabelColProps: { span: 8 },
  itemInputColProps: { span: 16 },
};

// 每个节点需要编辑的字段
export const nodeEditFieldsKey = {
  [NodeEnum.AWAITING_SUBMISSION_BIDS]: [
    'tender_plan_attach_blob_ids',
    'quote_price',
    'quote_currency',
    'quote_price_attach_blob_ids',
  ],
  [NodeEnum.BID_OPEN_REVIEW]: ['quote_price', 'quote_currency', 'quote_price_attach_blob_ids'],
};

export const getNodeBaseInfoMapComp = (params: any) => {
  const { detail = {}, ref, getDetail, ...reset } = params;
  const { state = '', permit_actions = {} } = detail;
  const { can_move, can_edit } = permit_actions;
  let component = null;
  const props = {
    ...reset,
    getDetail,
    detail,
    ref,
    editFields: can_move || can_edit ? nodeEditFieldsKey[state] || [] : [],
  };
  switch (state) {
    case NodeEnum.AWAITING_SUBMISSION_BIDS:
      component = <AwaitingSubmissionBids {...props} />;
      break;
    case NodeEnum.BID_OPEN_REVIEW:
      component = <BidOpenReview {...props} />;
      break;
    default:
      component = <Template {...props} />;
      break;
  }
  if (component) {
    return component;
  }
  return null;
};

export const nameEmailSearchHandler = (searchValue: string, items: Record<string, any>[]) => {
  const lcValue = searchValue.toLowerCase();
  return items.filter((item) => {
    const matchName = (item.name || '').toLowerCase().includes(lcValue);
    if (!matchName) {
      const matchEmail = (item.email || '').toLowerCase().includes(lcValue);
      return matchEmail;
    }
    return matchName;
  });
};

export const FinishApprovalOptions = [
  {
    name: '是',
    value: true,
  },
  {
    name: '否',
    value: false,
  },
];

export const transformToBlobIds = (fileList: Record<string, any>[] = []) => {
  return fileList
    .filter((v: any) => v.status === 'done')
    .map((file: any) => {
      const uploadResData = _.get(file, 'response.data');
      if (uploadResData) {
        return uploadResData.blob_id;
      }
      if (file.blob_id) {
        return file.blob_id;
      }
      return file.id;
    });
};

export const transformBlobidsToFileList = (ary: Record<string, any>[] = []) => {
  const fileList = ary
    .filter((attach: any) => !!attach.blob)
    .map((attach: any) => {
      return {
        attach_id: attach.id,
        uid: attach.blob.id,
        name: attach.blob.filename,
        size: attach.blob.byte_size,
        status: 'done',
        blob_id: attach.blob.id,
        blob_key: attach.blob.key,
      };
    });
  return fileList;
};

export enum FormMode {
  Edit = 'edit',
  Show = 'show',
}

export enum Priority {
  Middle = 'middle_level',
}

export enum Currency {
  RMB = 'rmb',
}
